import { Dtos } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useRequest } from "../../../utils/request";
import { adminAgencyPreviewsQueryKey } from "../agency.keys";

export const useAdminFetchAgencyPreviews = (shouldSkipQuery?: boolean) => {
	const { get } = useRequest();

	const { data, error, isLoading } = useQuery({
		queryKey: adminAgencyPreviewsQueryKey(),
		queryFn: async () => {
			if (shouldSkipQuery) {
				return [] as Dtos.Admin.Agency.Get.Preview.Response[];
			}
			return await get<Dtos.Admin.Agency.Get.Preview.Response[]>(`/v2/admin/agencies/previews`);
		},
	});

	// K/V map to avoid repeated .find calls
	const agencyNameMap = useMemo(() => {
		const map: Record<string, string> = {};
		if (!data || data.length === 0) return map;
		data.forEach((agency) => {
			map[agency.id] = agency.displayName;
		});
		return map;
	}, [data]);

	return {
		agencyPreviews: data,
		agencyPreviewsError: error,
		agencyPreviewsLoading: isLoading,
		agencyNameMap,
	};
};
